import React from 'react';

const ErrorState = ({ error, onRetry }) => {
  return (
    <div className="flex items-center justify-center h-screen" style={{ background: '#fafafa' }}>
      <div className="text-center max-w-sm px-6">
        <div className="mb-5">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#1d4ed8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ margin: '0 auto' }}>
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        </div>
        <h2 className="font-semibold mb-2" style={{ fontSize: '17px', color: '#111111', letterSpacing: '-0.01em' }}>
          Failed to load flight data
        </h2>
        <p className="mb-6 text-sm" style={{ color: '#6b7280', lineHeight: '1.5' }}>{error}</p>
        <button
          onClick={onRetry}
          className="transition-colors"
          style={{
            background: '#111111',
            color: '#ffffff',
            padding: '10px 24px',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '500',
            border: 'none',
            cursor: 'pointer',
          }}
          onMouseEnter={e => e.target.style.background = '#333333'}
          onMouseLeave={e => e.target.style.background = '#111111'}
        >
          Try again
        </button>
      </div>
    </div>
  );
};

export default ErrorState;